<div class="container">
    <nb-layout>
      <nb-layout-header>
        <div class="background"></div>
        <a id="sidebar-button" style="z-index: 12; margin-right: 10px" (click)="toggle()">
          <nb-icon [icon]="sideBarIcon"></nb-icon>
        </a>
        <div class="header">
          <a [routerLink]="isTournamentMode ? ['/tourney', entityCode] : ['/']">
            <img class="logo" src="images/ecl-logo.png" alt="ECL logo">
          </a>
          <div class="header-right-content">
            <app-language-switcher></app-language-switcher>

            <div class="header-separator"></div>

            @if (!isLoggedIn) {
              @if (isTournamentMode) {
                <a [routerLink]="['/tourney', entityCode, 'auth', 'login']">
                  <img class="pointer" src="images/ecl-user.png" alt="Sign in" [nbPopover]="'nav.sign_in' | translate" nbPopoverTrigger="hover">
                </a>
              }
              @else {
                <div id="user-actions">

                  <a routerLink="/teams/sign-up">
                    <div class="item">
                      <img src="images/sign-up.png" alt="Sign Up">
                      <div>{{ 'nav.sign_up' | translate }}</div>
                    </div>
                  </a>

                  <div class="line"></div>

                  <a routerLink="/teams/account">
                    <div class="item">
                      <img src="images/register.png" alt="Register">
                      <div>{{ 'nav.register' | translate }}</div>
                    </div>
                  </a>

                  <a id="login" routerLink="/auth/login">
                    <div class="item" [nbPopover]="'nav.login' | translate" nbPopoverTrigger="hover">
                      <img src="images/login.png" alt="Login">
                      <div>{{ 'nav.login' | translate }}</div>
                    </div>
                  </a>

                </div>
              }
            }
            @else {
              <div class="user-section">
                <span class="username">{{ user?.username }}</span>
                <nb-icon (click)="editAccountActivision()" class="parameters pointer" icon="settings-2-outline"></nb-icon>
                <a (click)="isTournamentMode ? tournamentLogout() : logout()">
                  <img class="pointer" src="images/logout.svg" alt="Sign out" [nbPopover]="'nav.sign_out' | translate" nbPopoverTrigger="hover">
                </a>
              </div>
            }
          </div>
        </div>
      </nb-layout-header>

      <nb-sidebar fixed="false" responsive
                  (responsiveStateChange)="onResponsiveStateChange($event)"
                  [compactedBreakpoints]="[]"
                  [collapsedBreakpoints]="['is', 'xs', 'sm', 'md']">
        <nb-menu tag="menu" [items]="items()"></nb-menu>
      </nb-sidebar>

      <nb-layout-column>
        <router-outlet></router-outlet>

        <div class="footer">
          {{ currentYear }}
        </div>
    </nb-layout-column>
  </nb-layout>
</div>
